import {cloneDeep} from 'lodash';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppointmentState, AppointmentTypeEnum, IAppointment} from '../../models/appointment';
import {IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';

@Component({
  selector: 'app-date-list',
  templateUrl: './date-list.component.html',
  styleUrls: ['./date-list.component.scss']
})
export class DateListComponent implements OnInit {
  // tslint:disable:no-output-native
  appointmentSelected$: Observable<IAppointment | undefined> = this.store.select<IAppointment | undefined>(AppointmentState.getAppointmentSelected);
  @Input() appointments: IAppointment[] = [];
  @Output() select: EventEmitter<IAppointment> = new EventEmitter();

  appointmentTypeEnum = AppointmentTypeEnum;
  userLogged: IUser;
  constructor(
    private storageService: StorageService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.userLogged = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
  }

  async onEmitSelected(appointment: IAppointment): Promise<void> {
    // Se cambio porque el redux modifica el id del appointment seleccionado
    const appointmentSelected = cloneDeep(await firstValueFrom((this.store.selectOnce(AppointmentState.getAppointmentSelected))));
    if (appointmentSelected?._id !== appointment._id) {
      this.select.emit(appointment);
    }
  }

}
